<template>
    <WrapBg title="" bgImg="myBg">
        <Crumbs title="密码设置"/>
        <div style="padding:0 80px 50px;">
            <el-form :model="password" ref="password" label-width="20px">
                <div><i class="iconfont icon-password-set"></i> 您要修改的是</div>
                <el-form-item>
                    <div style="margin:24px 0 8px; display: flex;">
                        <div :class="['modifyType',type==0?'active':'']" @click="type=0">修改登录密码</div>
                        <div :class="['modifyType',type==1?'active':'']" @click="type=1">修改支付密码</div>
                    </div>
                </el-form-item>
                <div><i class="iconfont icon-password-set"></i> 请输入原密码</div>
                <el-form-item class="mt-15" prop="oldPassword" :rules="[{ required: true, message: '请输入原密码'}]" >
                    <el-input v-model="password.oldPassword" class="width-300" placeholder="请输入原密码" type="password"></el-input>
                </el-form-item>
                <div><i class="iconfont icon-password-set"></i> 请输入新的密码</div>
                <el-form-item class="mt-15" prop="newPassword" :rules="[{ required: true, message: '请输入新密码'}]">
                    <el-input v-model="password.newPassword" maxlength="6" onkeyup="value=value.replace(/[^\d]/g,'')" class="width-300" placeholder="请输入6位数字新的密码" type="password"></el-input>
                </el-form-item>
                <el-form-item class="mt-15" prop="confirmPassword" :rules="[{ required: true, message: '请输入确认密码'}]">
                    <el-input v-model="password.confirmPassword" maxlength="6" onkeyup="value=value.replace(/[^\d]/g,'')"  class="width-300" placeholder="请输入确认密码" type="password"></el-input>
                </el-form-item>
                <div class="text-center mt-50">
                    <el-button v-if="type==0" type="primary" class="width-300" @click="submitForm('password')">提交</el-button>
                    <el-button v-if="type==1" type="danger" class="width-300" disabled>支付密码暂时无法修改</el-button>
                </div>
            </el-form>
        </div>
    </WrapBg>
</template>

<script>
    export default {
        name: "Password",
        data(){
            return{
                type:0,//类型：0登陆密码，1支付密码
                password:{
                    oldPassword:'',//原密码
                    newPassword:'',
                    confirmPassword:'',
                }
            }
        },
        methods:{
            submitForm(password) {
                this.$refs[password].validate((valid) => {
                    if (valid) {
                        if(this.password.confirmPassword != this.password.newPassword){
                            return this.$message.warning('两次密码输入不一致');
                        }
                        this.save();
                    }
                });
            },
            async save(){
                const loading = this.$loading({background: 'rgba(0, 0, 0, 0.3)'});
                let key = {};
                let e = await this.$unifiedApi({
                    api:this.$api.loginAdvance,
                    fn:this.save,
                });
                if(!e || !e.data) return;
                let keyData = e.data;
                if(keyData.respCode === '0000'){
                    key = {publicKey:keyData.obj.publicKey,sessionId:keyData.obj.securityId};
                }else {
                    this.$message.error(keyData.respInfo);
                }
                let url = this.type==0 ? this.$api.changePasswordLogin : this.$api.changePasswordPay;
                let oldPassword = await this.$encryptedData(key.publicKey,this.password.oldPassword);
                let newPassword = await this.$encryptedData(key.publicKey,this.password.newPassword);
                let res = await this.$unifiedApi({
                    api:url,
                    fn:this.save,
                    params:{
                        method:'member',devId:'WEB',
                        oldPassword:oldPassword,
                        newPassword: newPassword,
                        sessionId:key.sessionId,
                    }
                });
                if(!res || !res.data) return;
                let data = res.data;
                if(data.respCode === '0000'){
                    if(this.type==0){
                        this.$message.success('密码修改成功，请重新登录');
                        this.$store.dispatch('logout').then(() => {
                            this.$router.push('/login');
                        });
                        await this.$api.logout();
                    }else{
                        this.$message.success('支付密码修改成功');
                    }
                }else{
                    this.$message.error(data.respInfo);
                }
                loading.close();
            }
        }
    }
</script>

<style scoped>
    .modifyType{
        width:180px;
        height:80px;
        text-align: center;
        line-height: 80px;
        font-weight: 600;
        border:1px solid #aaa;
        margin-right:15px;
        border-radius: 4px;
        cursor: pointer;
    }
    .modifyType.active{
        border:1px solid blue;;
    }
    .icon-password-set{
        color:#ddd;
    }
</style>